/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_1_HInputs */

const en_terms_1_h = /** @type {(inputs: Terms_1_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The service`)
};

const id_terms_1_h = /** @type {(inputs: Terms_1_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layanan`)
};

/**
* | output |
* | --- |
* | "The service" |
*
* @param {Terms_1_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_1_h = /** @type {((inputs?: Terms_1_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_1_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_1_h(inputs)
	return en_terms_1_h(inputs)
});